/**
 * @generated SignedSource<<45a8c3db88bb4c5c762bfedd0ea8a2e6>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, GraphQLSubscription } from 'relay-runtime';
export type useWidgetTodoSubscriptionDeletedSubscription$variables = {
  categoryId: string;
  teamIds: ReadonlyArray<string>;
};
export type useWidgetTodoSubscriptionDeletedSubscription$data = {
  readonly todoDeleted: {
    readonly id: string;
  } | null;
};
export type useWidgetTodoSubscriptionDeletedSubscription = {
  response: useWidgetTodoSubscriptionDeletedSubscription$data;
  variables: useWidgetTodoSubscriptionDeletedSubscription$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "categoryId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "teamIds"
  }
],
v1 = [
  {
    "items": [
      {
        "kind": "Variable",
        "name": "categoryIds.0",
        "variableName": "categoryId"
      }
    ],
    "kind": "ListValue",
    "name": "categoryIds"
  },
  {
    "kind": "Variable",
    "name": "teamIds",
    "variableName": "teamIds"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useWidgetTodoSubscriptionDeletedSubscription",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Todo",
        "kind": "LinkedField",
        "name": "todoDeleted",
        "plural": false,
        "selections": [
          (v2/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Subscription",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useWidgetTodoSubscriptionDeletedSubscription",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Todo",
        "kind": "LinkedField",
        "name": "todoDeleted",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "filters": null,
            "handle": "deleteRecord",
            "key": "",
            "kind": "ScalarHandle",
            "name": "id"
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "01af5e3f98328546b9b0cfcc3209e894",
    "id": null,
    "metadata": {},
    "name": "useWidgetTodoSubscriptionDeletedSubscription",
    "operationKind": "subscription",
    "text": "subscription useWidgetTodoSubscriptionDeletedSubscription(\n  $categoryId: ID!\n  $teamIds: [ID!]!\n) {\n  todoDeleted(categoryIds: [$categoryId], teamIds: $teamIds) {\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "c33d5a0f67244c97489a3205635ef8e4";

export default node;
